import Logo from '../../comps/appLogo';
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import BoxMenuDrop from '../../comps/boxMenuDrop';
import ProfileMenuDrop from '../../comps/profileMenuDrop';
import { notifyWithToast } from '../../comps/templateToast';
import skills from '../../data/imgs/icons/app/skills.png';
import photos from '../../data/imgs/icons/app/photos.png';
import resume from '../../data/imgs/icons/app/resume.png';
import projects from '../../data/imgs/icons/app/projects.png';

import { getCachedImage, preloadImages } from '../../utils/utils';

export default () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [imageCache, setImageCache] = useState({
    resume: getCachedImage('resume'),
    skills: getCachedImage('skills'),
    photos: getCachedImage('photos'),
    projects: getCachedImage('projects')
  });

  const toggleDarkMode = () => {
    setIsDarkMode(prev => !prev);
  };

  useEffect(() => {
    // Update the entire page background and prevent scrolling
    document.body.style.backgroundColor = isDarkMode ? '#696969' : 'white';
    document.documentElement.style.backgroundColor = isDarkMode ? '#696969' : 'white';

    // Prevent scrolling
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.margin = '0';
    document.body.style.height = '100vh';
    document.documentElement.style.height = '100vh';

    // Cleanup when component unmounts
    return () => {
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.style.margin = '';
      document.body.style.height = '';
      document.documentElement.style.height = '';
    };
  }, [isDarkMode]);

  useEffect(() => {
    const imageConfigs = [
      { path: resume, key: 'resume' },
      { path: skills, key: 'skills' },
      { path: photos, key: 'photos' },
      { path: projects, key: 'projects' }
    ];

    preloadImages(imageConfigs).then(() => {
      setImageCache({
        resume: getCachedImage('resume') || resume,
        skills: getCachedImage('skills') || skills,
        photos: getCachedImage('photos') || photos,
        projects: getCachedImage('projects') || projects
      });
    });
  }, []);

  return (
    <>
      <br />
      <br />
      <div className="home main" style={{
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div className="top-menu"
          style={{ cursor: 'pointer', userSelect: 'none' }}>
          <BoxMenuDrop
            notifyWithToast={notifyWithToast}
            toggleColorMode={toggleDarkMode}
            isDarkMode={isDarkMode} />
          <ProfileMenuDrop />
        </div>
        <div className="flex-center" style={{ flex: 1, overflow: 'hidden' }}>
          <div className="search-container">
            <div className="frontpage-logo">
              <Logo />
            </div>
            <br />
            <div id="drop" style={{ userSelect: 'none' }}>
              <div className="drop-item-main">
                <Link className="drop-link" to="/projects">
                  <img
                    src={imageCache.projects || projects}
                    alt="Projects"
                    width="64"
                    height="64"
                    loading="lazy"
                  />
                  <p style={{ fontWeight: 'bold', fontSize: '13px' }}>Projects</p>
                </Link>

                <Link className="drop-link" to="/skills">
                  <img
                    src={imageCache.skills || skills}
                    alt="Skills"
                    width="64"
                    height="64"
                    loading="lazy"
                  />
                  <p style={{ fontWeight: 'bold', fontSize: '13px' }}>Skills</p>
                </Link>

                <Link className="drop-link" to="/photos">
                  <img
                    src={imageCache.photos || photos}
                    alt="Photos"
                    width="64"
                    height="64"
                    loading="lazy"
                  />
                  <p style={{ fontWeight: 'bold', fontSize: '13px' }}>Photos</p>
                </Link>

                <Link className="drop-link" to="/resume">
                  <img
                    src={imageCache.resume || resume}
                    alt="Resume"
                    width="64"
                    height="64"
                    loading="lazy"
                  />
                  <p style={{ fontWeight: 'bold', fontSize: '13px' }}>Resume</p>
                </Link>


              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


